import type { AISettings, GeneralSettings, IntegrationSettings, UISettings } from "./interface"

export const DEFAULT_SUMMARIZE_TIMELINE_SHORTCUT_ID = "default-summarize-timeline"
export const DEFAULT_RECOMMEND_FEEDS_SHORTCUT_ID = "default-recommend-feeds"

export const defaultGeneralSettings: GeneralSettings = {
  // App
  appLaunchOnStartup: false,
  language: "en",
  translation: false,
  translationMode: "bilingual",
  summary: true,
  actionLanguage: "default",

  sendAnonymousData: true,
  showQuickTimeline: true,

  // subscription
  autoGroup: true,
  hideAllReadSubscriptions: false,
  hidePrivateSubscriptionsInTimeline: false,

  // view
  unreadOnly: false,
  timelineSortOrder: "desc",
  // mark unread
  scrollMarkUnread: true,
  hoverMarkUnread: false,
  renderMarkUnread: false,
  // timeline
  groupByDate: false,
  autoExpandLongSocialMedia: false,
  autoPlayVideo: true,
  dimRead: false,

  // Secure
  jumpOutLinkWarn: true,
  // TTS
  voice: "en-US-AvaMultilingualNeural",

  // Pro feature
  enhancedSettings: false,

  // @mobile
  openLinksInExternalApp: false,
}

export const defaultUISettings: UISettings = {
  accentColor: "orange",

  // Sidebar
  entryColWidth: 450,
  aiColWidth: 384,
  feedColWidth: 256,
  hideExtraBadge: false,

  opaqueSidebar: false,
  sidebarShowUnreadCount: true,
  thumbnailRatio: "square",

  // Global UI
  uiTextSize: 16,
  // System
  showDockBadge: true,
  // Misc
  modalOverlay: true,
  modalDraggable: true,

  reduceMotion: false,
  usePointerCursor: false,

  // Font
  uiFontFamily: "system-ui",
  readerFontFamily: "inherit",
  contentFontSize: 16,
  dateFormat: "default",
  contentLineHeight: 1.75,
  // Content
  readerRenderInlineStyle: true,
  codeHighlightThemeLight: "github-light",
  codeHighlightThemeDark: "github-dark",
  guessCodeLanguage: true,
  hideRecentReader: false,
  customCSS: "",

  // View
  pictureViewMasonry: true,
  pictureViewImageOnly: false,
  wideMode: false,

  // Action Order
  toolbarOrder: {
    main: [],
    more: [],
  },

  showUnreadCountViewAndSubscriptionMobile: false,
  showUnreadCountBadgeMobile: false,

  // Discover
  discoverLanguage: "all",

  // Timeline tabs preset (excluding the first fixed tab)
  timelineTabs: {
    visible: [],
    hidden: [],
  },
}

export const defaultIntegrationSettings: IntegrationSettings = {
  // eagle
  enableEagle: false,

  // readwise
  enableReadwise: false,
  readwiseToken: "",

  // instapaper
  enableInstapaper: false,
  instapaperUsername: "",
  instapaperPassword: "",

  // obsidian
  enableObsidian: false,
  obsidianVaultPath: "",

  // outline
  enableOutline: false,
  outlineEndpoint: "",
  outlineToken: "",
  outlineCollection: "",

  // readeck
  enableReadeck: false,
  readeckEndpoint: "",
  readeckToken: "",

  // cubox
  enableCubox: false,
  cuboxToken: "",
  enableCuboxAutoMemo: false,

  // zotero
  enableZotero: false,
  zoteroUserID: "",
  zoteroToken: "",

  // qbittorrent
  enableQBittorrent: false,
  qbittorrentHost: "",
  qbittorrentUsername: "",
  qbittorrentPassword: "",

  saveSummaryAsDescription: false,

  // custom actions
  enableCustomIntegration: false,
  customIntegration: [],

  // fetch preferences (Electron only)
  useBrowserFetch: false,
}

export const defaultAISettings: AISettings = {
  personalizePrompt: "",
  aiTimelinePrompt: "",
  shortcuts: [],

  // MCP Services
  mcpEnabled: false,
  mcpServices: [],

  // Features
  autoScrollWhenStreaming: true,

  // BYOK (Bring Your Own Key)
  byok: {
    enabled: false,
    providers: [],
  },
}

export const defaultSettings = {
  general: defaultGeneralSettings,
  ui: defaultUISettings,
  integration: defaultIntegrationSettings,
  ai: defaultAISettings,
}
